import { Banner, BaseBannersClient } from "@core/types";

class BannersClient extends BaseBannersClient {
  async getBanners() {
    const response = await this.instance.get<any>(`banner/list/active?position=1`);

    const banners: Banner[] = response.data.map((banner: any) => {
      return {
        id: banner.id,
        imageSrc: banner.imageUrl,
      } as Banner;
    });

    return banners;
  }
}

export default BannersClient;
